import { Stack, Typography } from '@mui/material';
import MuiAvatar from '@mui/material/Avatar';
import avatar from 'assets/images/avatar.svg';
import { Me } from 'store/user/types';
import LogoutButton from './LogoutButton';

interface IUserProps {
  me: Me;
  isMobile: boolean;
}

const User = ({ me, isMobile }: IUserProps) => {
  return (
    <Stack
      direction={isMobile ? 'column' : 'row'}
      spacing={2}
      sx={{
        justifyContent: 'flex-end',
        alignItems: { xs: 'flex-start', md: 'center' },
        width: { xs: '100%', md: 'auto' },
      }}>
      <Stack direction='row' spacing={2} alignItems='center'>
        <MuiAvatar src={avatar} />
        <Typography variant='body16rg'>
          {me?.firstCompanyCandidate?.fullName || me?.fullName}
        </Typography>
      </Stack>
      <LogoutButton isMobile={isMobile} />
    </Stack>
  );
};

export default User;
